import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { HttpService } from 'app/services';
import * as _ from 'lodash';
import { BaseModal } from '../base-modal';
import { locale as english } from '../i18n/en';

@Component({
    selector: 'app-sensor-sensitivity-modal',
    templateUrl: './sensor-sensitivity-modal.component.html',
    styleUrls: ['./sensor-sensitivity-modal.component.scss'],
})
export class SensorSensitivityModalComponent
extends BaseModal {
  device: any;
  sensitivity: number = 0;
  saving: boolean = false;
  private modalService: any;

  constructor(
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      protected dialogRef: MatDialogRef < SensorSensitivityModalComponent >,
      private httpService: HttpService,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);       
    this._fuseTranslationLoaderService.loadTranslations(english);
    this.device = data.device;
    this.modalService = data.parentRef;
    this.sensitivity = this.device.sensitivity_change_value || this.device.sensr_setting;
  }

  onChange(e){
    this.sensitivity = e.value;
  }

  get closeDisabled(){
    return this.dialogRef.disableClose;
  }

  save(){
    if(this.sensitivity == this.device.sensr_setting)
      return this.dialogRef.close();
    this.dialogRef.disableClose = true;
    let body = {
      sensitivity_change_value: this.sensitivity < 1 ? 1 : this.sensitivity > 10 ? 10 : this.sensitivity,
      sensitivity_changed: true
    };

    this.httpService.patchDevice(this.device.id, body, true).toPromise().then((res: any) => {
      if(res?.count == 1)
        return this.dialogRef.close(body);
      this.modalService.showModal('Error', 'Failed to save changes. Please try again.')
    }).catch(err => {
      this.modalService.errorDialog(err);
    })
  }
}